import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidModelById,
    LoadQidModelSafetyFunctionById,
    setQidModelEditSafetyFunction,
    setQidModelReloadEditSafetyFunction,
    initQidModelSafetyFunction,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface QidModelSafetyFunctionEditProps {
    modelId: number
    safetyFunctionId: number
}

const Edit = ({
    modelId = null,
    safetyFunctionId = null,
}: QidModelSafetyFunctionEditProps) => {
    const safetyFunction = useSelector((state: StoreType) => state.qidModel.editSafetyFunction)
    const reloadEdit = useSelector((state: StoreType) => state.qidModel.reloadEditSafetyFunction)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setQidModelReloadEditSafetyFunction(false))
        setTimeout(() => {
            dispatch(setQidModelReloadEditSafetyFunction(true))
        }, 0)
    }

    useEffect(() => {
        setLoadState(PENDING)
        if (safetyFunctionId === 0) {
            LoadQidModelById(modelId).then((model) => {
                dispatch(setQidModelEditSafetyFunction({
                    ...initQidModelSafetyFunction,
                    modelId: model.id,
                    type: model.type,
                    lowDemandMode: model.lowDemandMode,
                    highDemandMode: model.highDemandMode,
                    continuousMode: model.continuousMode,
                    logicSolver: model.logicSolver,
                    provenInUse: model.provenInUse,
                }))

                setLoadState(IDLE)
                reload()
            })
        } else {
            LoadQidModelSafetyFunctionById(safetyFunctionId).then((res) => {
                dispatch(setQidModelEditSafetyFunction(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!safetyFunction) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {safetyFunction.id ? `${lang.editSafetyFunction} # ${safetyFunction.id}` : lang.addSafetyFunction}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form safetyFunction={safetyFunction} />
                }
                {
                    reloadEdit
                    && <Form safetyFunction={safetyFunction} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
